import { axios } from '@/services/axios';

/**
 * Submit multiple number blocks.
 *
 * @param {object} formData - Header fields + items payload
 * @param {boolean} [queue=false] - When true, adds `?queue=true` so the backend
 *   queues the request (Create Order) instead of processing it directly (Live Upload).
 */
export async function postNumberBlocks(formData, queue = false) {
    return await axios.post(
        `/NumberBlocks${queue ? '?queue=true' : ''}`,
        formData,
    );
}
